"use client";
import { useAuthConfig } from "../../../hooks/internal/useAuthConfig.js";
import { getWalletConnectParams } from "../../../utils.js";
export const useWalletConnectAuthConfig = () => {
    const walletConnectAuthConfig = useAuthConfig((auth) => {
        const externalWalletSection = auth.sections
            .find((x) => x.some((y) => y.type === "external_wallets"))
            ?.find((x) => x.type === "external_wallets");
        return externalWalletSection?.walletConnect;
    });
    // Add z-index to the wallet connect modal if not already set
    const walletConnectParams = getWalletConnectParams(walletConnectAuthConfig);
    return {
        walletConnectParams,
        walletConnectAuthConfig,
    };
};
//# sourceMappingURL=useWalletConnectAuthConfig.js.map